module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basicInfo tableBox"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("作业详情")]), _vm._v(" "), (_vm.workList) ? _c('noFound') : _c('table', [_c('tr', [_c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("排名")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("完成情况")]), _vm._v(" "), _c('th', {
    staticClass: "fixTitle"
  }, [_vm._v("总分 ")])]), _vm._v(" "), _vm._l((_vm.userList.slice(0, 10)), function(item, i) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(i + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.finishCount) + " / " + _vm._s(item.totalWork))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalScore))])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    staticClass: "loadMore",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("点击查看更多作业详情>>")])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6efd52","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reportTable/reportTable.vue
// module id = 1164
// module chunks = 1